<template>
  <div class="main">
    <div class="box">
      <div class="header">
        <el-breadcrumb v-if="$route.query.path" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: `/${this.$route.query.path}` }">流程配置</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-breadcrumb v-else separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/purchaseRequisition' }">采购申请</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="table">
        <div class="table-top">
          <div class="grid-search">
              <!-- <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="margin-right:1vw;"
                  @change="doFilter"
              ></el-date-picker> -->
              <el-input v-model="search.name" style="width:200px" placeholder="请输入物资名称" clearable @change="doFilter">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <div class="btns">
              <button class="addwuzi" style="margin-right:10px">导出表格</button>
            </div>
        </div>
        <div class="cont-box">
          <div class="title">
          <div class="item" style="width:8%;">序号</div>
          <div class="item" style="width:8%;">材料类型</div>
          <div class="item" style="width:20%;">材料名称</div>
          <div class="item" style="width:20%;">材料型号</div>
          <div class="item" style="width:20%;">材料品牌</div>
          <div class="item" style="width:20%;">数量</div>
          <div class="item" style="width:8%;">单价</div>
          <div class="item" style="width:20%;">金额</div>
          <div class="item" style="width:25%;">生产厂家</div>
          <div class="item" style="width:25%;">供应商</div>
        </div>
        <div class="scroll">
          <div class="content-i" v-for="(item,index) in personList" :key="index">
          <div class="text" style="width:8%;">{{(pageNum-1)*pageSize+index+1}}</div>
          <div class="text" style="width:8%;">{{item.materialTypeName}}</div>
          <div class="text" style="width:20%;">{{item.materialName}}</div>
          <div class="text" style="width:20%;">{{item.materialModel}}</div>
          <div class="text" style="width:20%;">{{item.materialBrand}}</div>
          <div class="text" style="width:20%;">{{item.amount}}</div>
          <div class="text" style="width:8%;">{{item.unitPrice}}</div>
          <div class="text" style="width:20%;">{{item.money}}</div>
          <div class="text" style="width:25%;">{{item.materialManufacturer}}</div>
          <div class="text" style="width:25%;">{{item.materialSupplier}}</div>
        </div>
        </div>
        </div>
        <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      listData: [
        
      ],
      search: {
        //查询
        name:'',
        // name: '',
        // projectId: '',
        // date:util.myTime.getCurTime(),
        // temperatureType:'2',
        // teamsId: '',
        // entId: '',
        // personName: '',
      },
      dataText: '数据加载中...',
      
      currentPage: 1,
      pageSize: 10,
      totalItems: 4,
      modifyVisible: false,
      workerInfo: {
        id: '',
        name:'',
        count:0,
        place:'',
        remarks:'',
        createBy:'',
        projectId:''
      },
      rules:{
        name:[
           { required: true, message: '请输入', trigger: 'blur' }
        ],
        count:[
           { required: true, message: '数量不能为空'}
        ]
      },
      //检查事项列表
      napeList:[],
      //责任单位
      entList:[],
      //责任人
      personList:[],
      //使用列表
      listHistory:[],
      dataText1:'数据加载中...',
      hisVis:false,
      num:0,
      num1:0,
      pageSize:10,
      pageNum:1
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleSizeChange(val) {
      console.log('改变了')
        this.pageSize = val
        this.pageNum=1
        this.getData()
    },
    handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getData()
    },
    // 搜索数据
    doFilter(index) {
      this.getData()
    },
    getData(){
      let that = this
      myHttp.findPurchasePlanSupplierPage({
        projectId:that.$route.query.projectId,
        orderNumber:that.$route.query.orderNumber,
        pageSize:this.pageSize,
        pageNum:this.pageNum
      }).then(res=>{
        console.log(res)
        if(res.data.code==200){
          this.personList=res.data.data.purchasePlanSupplierPage.list
        }
      })
    }
    // 获取数据
    // getData() {
    //   var that = this
    //   this.search.pageSize = this.pageSize
    //   this.search.pageNum = this.currentPage
    //   myHttp.selectProEmergencySuppliesPage(this.search).then(
    //     function(resp) {
    //       if (resp.data.code == '200') {
    //         var list = resp.data.data.pageInfo.list || []
    //         for(var i=0;i<list.length;i++){
    //           list[i].index = (i+1)+(that.currentPage-1)*that.pageSize
    //         }
    //         that.listData = list
    //         if (that.listData.length == 0) {
    //           that.dataText = '暂无数据'
    //         }else{
    //           that.totalItems = resp.data.data.pageInfo.total||0
    //         }
    //       } else {
    //         that.$message.error(resp.data.msg)
    //         that.dataText = '暂无数据'
    //       }
    //     },
    //     function() {}
    //   )
    // },
    
  }
}
</script>
<style>
  @import '../../../assets/css/common.css';
</style>
<style scoped>
.main{
  flex: 1;
  height: 100%;
  background-color: #F3F8FC;
  padding-left:8px ;
  padding-right:24px ;
}
.table{
  height: 83vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0vw 0vw 0.4vw 0vw 
		rgba(105, 159, 204, 0.5);
}
.table::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.scroll{
  height: 66vh;
  overflow: scroll;
}
.scroll::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.table-top{
  min-height: 6vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 9px 0 9px;
}
.addwuzi{
  background-color: #0b62f0;
  color: #fff;
  width: 90px;
  height: 4vh;
  font-family: PingFang-SC-Medium;
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.addwuzi:hover{
  opacity: 0.6;
}
.title{
  height: 6vh;
  min-height: 6vh;
  background-color: #dfe1e3;
  display: flex;
  font-family: PingFang-SC-Bold;
	font-size: 22px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.item, .text{
  /* flex: 1; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-i{
  min-height: 6vh;
  display: flex;
  background-color: #fff;
  border-bottom: 2px solid #e7e7e7;
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.content-i:hover{
  background-color: #e1edf8;
}
.btn{
  display: flex;
  justify-content: center;
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0vh;
	color: #2e5be9;
}
.btn>.btn-l{
  margin-right: 5px;
}
.btn>.btn-l:hover{
  cursor: pointer;
  opacity: 0.7;
}
.btn>.btn-r{
  margin-left: 5px;
}
.btn>.btn-r:hover{
  cursor: pointer;
  opacity: 0.7;
}
.header{
  display: flex;
  min-height: 6vh;
  line-height: 6vh;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #000000;
}
.el-pagination{
  background-color: #dfe1e3;
}
.cont-box{
  overflow-y: hidden;
}
.title, .scroll{
  width: 100%;
}

.el-dialog__title{
  margin-left: 210px;
}
.dialog-footer{
  display: flex;
  justify-content: center;
}
.btns1{
  width: 65%;
  display: flex;
  justify-content: space-between;
}
.btn1{
  font-size: 16px;
  color: #2e5be9;
}
.btn1:hover{
  cursor: pointer;
  opacity: 0.7;
}
.red{
  color: #f00;
}
.el-pagination {
    padding: 1.2vh 1vh !important;
}
.el-breadcrumb{
  font-size: 18px;
  display: flex;
  align-items: center;
}
::v-deep .is-link {
  font-weight: 500 !important;
}
</style>